import { countries, countriesTranslations } from '@nxt-insurance/constants'
import type { AvailableCountryCodes, Language } from '@nxt-insurance/constants'

export interface TranslatedCountry {
  flag: string
  dial_code: string
  label: string
  code: AvailableCountryCodes
}

export const getTranslatedCountryList = (language: Language): TranslatedCountry[] => {
  return (Object.keys(countries) as AvailableCountryCodes[]).map((countryCode) => {
    return {
      ...countries[countryCode],
      label: countriesTranslations[language][countryCode],
      code: countryCode,
    }
  })
}
